module.exports = __webpack_public_path__ + "components/MapControl/svg/Pole bitwy.svg?6057f5ce";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Pole bitwy.svg
// module id = 2077
// module chunks = 0